module.exports = __webpack_public_path__ + "img/combination_fingerprint.25df1df.jpg";